import React, { useState } from "react";
import "./AccountPage.css";
import Toast from '../../components/reusable/Toast';
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import withRouter from "pages/withRouter";
import BracksetHeader from "components/reusable/BracksetHeader";
import NavigationTabs from "components/reusable/NavigationTabs";
import NavigationPanel from "components/reusable/NavigationPanel";
import { useNavigate } from "react-router-dom";
import AccountPageContent from "./AccountPageContent";


const AccountPage = props => {
    const navigate = useNavigate();

    const accountId = props.params.accountId;
    if(!accountId){
        navigateToLandingPage({routerNav: navigate})
    }

    const [toastMessages, setToastMessages] = useState([]);

    
  
             
    return (
        <>
            <div className="brackset-container">
                <div className="home-nav-container">
                    <NavigationPanel></NavigationPanel>
                    <div className="user-account-info-content">
                        <div className="account-content">
                            <BracksetHeader></BracksetHeader>
                            <AccountPageContent accountId={accountId}></AccountPageContent>
                        </div>
                    </div>
                </div>
                <NavigationTabs hideDesktop="true"></NavigationTabs>
                {/* <BracksetFooter></BracksetFooter> */}
            </div>
            <Toast toastList={toastMessages} position="top-left" autoDelete="true" autoDeleteTime="5000" />
        </>
    );
}

export default withRouter(AccountPage);
